import {FETCH_INFORMATION_REQUEST, FETCH_INFORMATION_SUCCES, FETCH_INFORMATION_ERROR} from '../constants/Information'

const initialState = {
  item: {},
  hasErrored: false,
  isLoading: false
}

export default function information(state = initialState, action) {
  switch (action.type) {
      case FETCH_INFORMATION_REQUEST:
        return {...state, isLoading: true};
      case FETCH_INFORMATION_SUCCES:
        return {...state, item: action.payload, isLoading: false};
      case FETCH_INFORMATION_ERROR:
        return {...state, hasErrored: true, isLoading: false};
      default:
          return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/information.js